@if (sectionsEnabled.colors) {
  <mat-expansion-panel [expanded]="!emailSetup.colors.collapsed">
    <mat-expansion-panel-header [expandedHeight]="'48px'">
      <mat-panel-title>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.COLORS.COLORS' | translate }}</mat-panel-title>
      @if (emailSetup.colors.isValid === false) {
        <mat-icon class="error-icon">error</mat-icon>
      }
    </mat-expansion-panel-header>
    <div class="wrapper">
      <form #colorForm="ngForm">
        <div class="form-grid-layout">
          <glxy-form-field horizontalLayout="true">
            <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.COLORS.TEXT' | translate }}</glxy-label>
            <input matInput type="color" [(ngModel)]="emailSetup.colors.textColor" name="textColor" />
            <input
              matInput
              type="text"
              [(ngModel)]="emailSetup.colors.textColor"
              name="textColor hex"
              [pattern]="colorRegex"
              #textColor="ngModel"
            />
            @if (textColor.hasError('pattern') && textColor.touched) {
              <glxy-error>
                {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.COLOR' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
          <mat-divider />
          <glxy-form-field horizontalLayout="true">
            <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.COLORS.TITLE' | translate }}</glxy-label>
            <input matInput type="color" [(ngModel)]="emailSetup.colors.titleColor" name="titleColor" />
            <input
              matInput
              type="text"
              [(ngModel)]="emailSetup.colors.titleColor"
              name="titleColor hex"
              [pattern]="colorRegex"
              #titleColor="ngModel"
            />
            @if (titleColor.hasError('pattern') && titleColor.touched) {
              <glxy-error>
                {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.COLOR' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
          <mat-divider />
          <glxy-form-field horizontalLayout="true">
            <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.COLORS.SUBTITLE' | translate }}</glxy-label>
            <input matInput type="color" [(ngModel)]="emailSetup.colors.subtitleColor" name="subtitleColor" />
            <input
              matInput
              type="text"
              [(ngModel)]="emailSetup.colors.subtitleColor"
              name="subtitleColor hex"
              [pattern]="colorRegex"
              #subtitleColor="ngModel"
            />
            @if (subtitleColor.hasError('pattern') && subtitleColor.touched) {
              <glxy-error>
                {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.COLOR' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
          <mat-divider />
          <glxy-form-field horizontalLayout="true">
            <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.COLORS.LINKS' | translate }}</glxy-label>
            <input matInput type="color" [(ngModel)]="emailSetup.colors.linkColor" name="linkColor" />
            <input
              matInput
              type="text"
              [(ngModel)]="emailSetup.colors.linkColor"
              name="linkColor hex"
              [pattern]="colorRegex"
              #linkColor="ngModel"
            />
            @if (linkColor.hasError('pattern') && linkColor.touched) {
              <glxy-error>
                {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.COLOR' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
          <mat-divider />
          <glxy-form-field horizontalLayout="true">
            <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.COLORS.FOOTER_TEXT' | translate }}</glxy-label>
            <input matInput type="color" [(ngModel)]="emailSetup.colors.footerTextColor" name="footerTextColor" />
            <input
              matInput
              type="text"
              [(ngModel)]="emailSetup.colors.footerTextColor"
              name="footerTextColor hex"
              [pattern]="colorRegex"
              #footerTextColor="ngModel"
            />
            @if (footerTextColor.hasError('pattern') && footerTextColor.touched) {
              <glxy-error>
                {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.COLOR' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
          <mat-divider />
          <glxy-form-field horizontalLayout="true">
            <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.COLORS.CONTENT_BACKGROUND' | translate }}</glxy-label>
            <input matInput type="color" [(ngModel)]="emailSetup.colors.textBackground" name="textBackground" />
            <input
              matInput
              type="text"
              [(ngModel)]="emailSetup.colors.textBackground"
              name="textBackground hex"
              [pattern]="colorRegex"
              #textBackground="ngModel"
            />
            @if (textBackground.hasError('pattern') && textBackground.touched) {
              <glxy-error>
                {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.COLOR' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
          <mat-divider />
          <glxy-form-field horizontalLayout="true">
            <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.COLORS.PAGE_BACKGROUND' | translate }}</glxy-label>
            <input matInput type="color" [(ngModel)]="emailSetup.colors.pageBackground" name="pageBackground" />
            <input
              matInput
              type="text"
              [(ngModel)]="emailSetup.colors.pageBackground"
              name="pageBackground"
              [pattern]="colorRegex"
              #pageBackground="ngModel"
            />
            @if (pageBackground.hasError('pattern') && pageBackground.touched) {
              <glxy-error>
                {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.COLOR' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
        </div>
      </form>
    </div>
  </mat-expansion-panel>
}

@if (sectionsEnabled.pageSetup) {
  <mat-expansion-panel [expanded]="!emailSetup.pageSetup.collapsed">
    <mat-expansion-panel-header [expandedHeight]="'48px'">
      <mat-panel-title>
        {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.SIZING_SPACING' | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <form #sizingAndSpacingForm="ngForm">
        <glxy-form-field suffixText="px">
          <glxy-label>
            {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.TOP_PADDING.TEXT' | translate }}
          </glxy-label>
          <glxy-hint>
            {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.TOP_PADDING.DEFAULT' | translate }}
          </glxy-hint>
          <input
            matInput
            type="number"
            placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
            name="Top Padding"
            [(ngModel)]="emailSetup.pageSetup.topPadding"
          />
        </glxy-form-field>
        <div class="row row-gutters">
          <glxy-form-field suffixText="px" class="col col-xs-12 col-sm-6">
            <glxy-label>
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.OUTER_WIDTH.TEXT' | translate }}
            </glxy-label>
            <glxy-hint>
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.OUTER_WIDTH.DEFAULT' | translate }}
            </glxy-hint>
            <input
              matInput
              type="number"
              placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
              name="Outer Width"
              [(ngModel)]="emailSetup.pageSetup.outerWidth"
            />
          </glxy-form-field>
          <glxy-form-field suffixText="px" class="col col-xs-12 col-sm-6">
            <glxy-label>
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.INNER_WIDTH.TEXT' | translate }}
            </glxy-label>
            <glxy-hint>
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.INNER_WIDTH.DEFAULT' | translate }}
            </glxy-hint>
            <input
              matInput
              type="number"
              placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
              name="Inner Width"
              [(ngModel)]="emailSetup.pageSetup.innerWidth"
            />
          </glxy-form-field>
        </div>
        <div class="row row-gutters">
          <glxy-form-field suffixText="px" class="col col-xs-12 col-sm-6">
            <glxy-label>
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.INNER_HORIZONTAL_PADDING.TEXT' | translate }}
            </glxy-label>
            <glxy-hint>
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.INNER_HORIZONTAL_PADDING.DEFAULT' | translate }}
            </glxy-hint>
            <input
              matInput
              type="number"
              placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
              name="Inner Horizontal Padding"
              [(ngModel)]="emailSetup.pageSetup.innerHorizontalPadding"
            />
          </glxy-form-field>
          <glxy-form-field suffixText="px" class="col col-xs-12 col-sm-6">
            <glxy-label>
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.BOTTOM_CONTENT_PADDING.TEXT' | translate }}
            </glxy-label>
            <glxy-hint>
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.SIZING_AND_SPACING.BOTTOM_CONTENT_PADDING.DEFAULT' | translate }}
            </glxy-hint>
            <input
              matInput
              type="number"
              placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
              name="Bottom Content Padding"
              [(ngModel)]="emailSetup.pageSetup.bottomContentPadding"
            />
          </glxy-form-field>
        </div>
      </form>
    </div>
  </mat-expansion-panel>
}

@if (sectionsEnabled.topLogo) {
  <mat-expansion-panel [expanded]="!emailSetup.topLogo.collapsed">
    <mat-expansion-panel-header [expandedHeight]="'48px'">
      <mat-panel-title>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.TEXT' | translate }}</mat-panel-title>
      @if (emailSetup.topLogo.isValid === false) {
        <mat-icon class="error-icon">error</mat-icon>
      }
    </mat-expansion-panel-header>
    <div class="wrapper">
      <form #topLogoForm="ngForm">
        <glxy-form-field>
          <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.TEXT' | translate }}</glxy-label>
          <mat-button-toggle-group name="Top Logo toggle" [(ngModel)]="emailSetup.topLogo.showLogo">
            <mat-button-toggle [value]="'show'">
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.DEFAULT' | translate }}
            </mat-button-toggle>
            <mat-button-toggle [value]="'custom'">
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.CUSTOM' | translate }}
            </mat-button-toggle>
            <mat-button-toggle [value]="'hide'">
              {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.HIDE' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </glxy-form-field>
        @if (emailSetup.topLogo.showLogo === 'custom') {
          @if (emailSetup.topLogo.customImageUrl) {
            <glxy-form-field>
              <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.CUSTOM_LOGO' | translate }}</glxy-label>
              <div class="row row-gutters">
                <div class="image-upload-wrapper col col-xs-12 col-sm-6">
                  <glxy-image-upload-tile
                    [showDeleteButton]="true"
                    [status]="FileUploadStatus.Queued"
                    [url]="emailSetup.topLogo.customImageUrl"
                    (delete)="emailSetup.topLogo.customImageUrl = null; this.emailPreview.refresh()"
                  />
                </div>
                <div class="image-controls col col-xs-12 col-sm-6">
                  <glxy-button-group>
                    <a mat-stroked-button target="_blank" rel="noopener" [href]="emailSetup.topLogo.customImageUrl">
                      {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.VIEW' | translate }}
                    </a>
                    <button
                      mat-stroked-button
                      (click)="emailSetup.topLogo.customImageUrl = null; this.emailPreview.refresh()"
                    >
                      {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.CLEAR' | translate }}
                    </button>
                  </glxy-button-group>
                </div>
              </div>
            </glxy-form-field>
          } @else {
            <glxy-form-field>
              <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.CUSTOM_LOGO' | translate }}</glxy-label>
              <glxy-image-uploader
                #imageUploader
                [autoUpload]="true"
                [maxFiles]="1"
                [hintText]="'ADD_SOMETHING_HINT' | translate"
                (fileUploadErrored)="
                  emailSetup.topLogo.customImageUrl =
                    'https://storage.googleapis.com/marketing-email-content/mountain-media-logo-360px.png';
                  this.emailPreview.refresh()
                "
                (fileUploaded)="setContentImage($event)"
              />
            </glxy-form-field>
          }
        }
        @if (emailSetup.topLogo.showLogo !== 'hide') {
          <div class="row row-gutters">
            <glxy-form-field suffixText="px" class="col col-xs-12 col-sm-6">
              <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.LOGO_WIDTH.TEXT' | translate }}</glxy-label>
              <input
                matInput
                type="number"
                pattern="[0-9]*"
                inputmode="numeric"
                name="Logo Width"
                placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
                [(ngModel)]="emailSetup.topLogo.width"
                emailHoldShiftToChangeNumberFieldByTen
              />
              <glxy-hint>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.LOGO_WIDTH.DEFAULT' | translate }}</glxy-hint>
            </glxy-form-field>
            <glxy-form-field class="col col-xs-12 col-sm-6">
              <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.LOGO_ALIGNMENT.TEXT' | translate }}</glxy-label>
              <select matInput [(ngModel)]="emailSetup.topLogo.align" name="Logo Alignment">
                <option [ngValue]="'center'">
                  {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.LOGO_ALIGNMENT.CENTER' | translate }}
                </option>
                <option value="left">
                  {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.LOGO_ALIGNMENT.LEFT' | translate }}
                </option>
                <option value="right">
                  {{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.LOGO_ALIGNMENT.RIGHT' | translate }}
                </option>
              </select>
            </glxy-form-field>
          </div>
          <div class="row row-gutters">
            <glxy-form-field suffixText="px" class="col col-xs-6">
              <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.TOP_PADDING.TEXT' | translate }}</glxy-label>
              <input
                matInput
                type="number"
                pattern="[0-9]*"
                inputmode="numeric"
                name="Top Padding"
                placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
                [(ngModel)]="emailSetup.topLogo.topPadding"
                emailHoldShiftToChangeNumberFieldByTen
              />
              <glxy-hint>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.TOP_PADDING.DEFAULT' | translate }}</glxy-hint>
            </glxy-form-field>
            <glxy-form-field suffixText="px" class="col col-xs-6">
              <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.BOTTOM_PADDING.TEXT' | translate }}</glxy-label>
              <input
                matInput
                type="number"
                pattern="[0-9]*"
                inputmode="numeric"
                name="Bottom Padding"
                placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
                [(ngModel)]="emailSetup.topLogo.bottomPadding"
                emailHoldShiftToChangeNumberFieldByTen
              />
              <glxy-hint>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.BOTTOM_PADDING.DEFAULT' | translate }}</glxy-hint>
            </glxy-form-field>
          </div>
          <glxy-form-field>
            <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.TOP_LOGO.LINK' | translate }}</glxy-label>
            <input
              matInput
              type="text"
              name="linkUrl-topLogo"
              autocomplete="off"
              placeholder="https://"
              [(ngModel)]="emailSetup.topLogo.link"
              [pattern]="urlMailtoOrDynamicContentRegex"
              #topLogoLink="ngModel"
            />
            @if (topLogoLink.hasError('pattern') && topLogoLink.touched) {
              <glxy-error>
                {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.LINK' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
        }
      </form>
    </div>
  </mat-expansion-panel>
}

@if (sectionsEnabled.footer) {
  <mat-expansion-panel [expanded]="!emailSetup.footer.collapsed">
    <mat-expansion-panel-header [expandedHeight]="'48px'">
      <mat-panel-title>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.FOOTER.TEXT' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <form #footerForm="ngForm">
        <glxy-form-field>
          <glxy-label>{{ 'EMAIL_BUILDER.ADVANCED_SETTINGS.FOOTER.DISCLAIMER' | translate }}</glxy-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5"
            name="Footer Disclaimer"
            placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
            [(ngModel)]="emailSetup.footer.disclaimer"
          ></textarea>
        </glxy-form-field>
      </form>
    </div>
  </mat-expansion-panel>
}
